var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgHeartFilled = function SvgHeartFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 14,
    fill: "none",
    viewBox: "0 0 16 14"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M0 4.555q0-1 .334-1.833A4.3 4.3 0 0 1 1.27 1.28Q1.88.673 2.699.336A4.6 4.6 0 0 1 4.479 0q1.103 0 2.055.544.96.537 1.47 1.441A3.75 3.75 0 0 1 9.466.545 4.1 4.1 0 0 1 11.53 0q.96 0 1.771.336.82.337 1.42.945.61.608.945 1.44.334.834.334 1.834 0 1.632-.96 3.233-.953 1.602-2.666 3.13-1.703 1.52-3.944 2.93-.091.056-.209.104a.6.6 0 0 1-.217.048.6.6 0 0 1-.217-.048 2 2 0 0 1-.217-.104q-2.24-1.41-3.944-2.93Q1.922 9.39.961 7.788 0 6.188 0 4.555"
  })));
};
export default SvgHeartFilled;